<template>
    <div
      :class="[
        fullscreen ? 'loader-overlay' : 'loader-inline',
        darkMode ? 'dark' : ''
      ]"
      v-if="visible"
    >
      <div class="loader-box">
        <lottie-player
          v-if="lottieUrl"
          :src="lottieUrl"
          background="transparent"
          speed="1"
          style="width: 120px; height: 120px"
          loop
          autoplay
        ></lottie-player>
  
        <div v-else class="spinner"></div>
  
        <p v-if="message" class="loader-message">{{ message }}</p>
      </div>
    </div>
  </template>
  
  <script>

import "@lottiefiles/lottie-player";
  export default {
    name: "AdvancedLoader",
    props: {
      visible: { type: Boolean, default: false },
      message: { type: String, default: "" },
      lottieUrl: { type: String, default: "" },
      darkMode: { type: Boolean, default: false },
      fullscreen: { type: Boolean, default: false },
      autoHideAfter: { type: Number, default: 0 }
    },
    data() {
      return { timer: null };
    },
    watch: {
      visible(newVal) {
        if (newVal && this.autoHideAfter > 0) {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            this.$emit("update:visible", false);
          }, this.autoHideAfter);
        }
      }
    },
    beforeDestroy() {
      clearTimeout(this.timer);
    }
  };
  </script>
  
  <style scoped>
  .loader-overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(255, 255, 255, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    flex-direction: column;
    text-align: center;
    transition: background-color 0.3s ease;
  }

  .loader-inline {
    padding: 2rem 0;
    width: 100%;
    position: relative;
    width: 100%;
    height: 80vh;
    
    border-radius: 12px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    background-color: rgba(255, 255, 255, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    flex-direction: column;
    text-align: center;
    transition: background-color 0.3s ease;
  }
  
  .loader-overlay.dark , .loader-inline.dark {
    background-color: rgba(0, 0, 0, 0.5);
  }
  
  
  
  .loader-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width:440px;
  }
  
  .spinner {
    width: 50px;
    height: 50px;
    border: 6px solid #ccc;
    border-top: 6px solid #409eff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  .loader-message {
    margin-top: 1rem;
    font-size: 16px;
    color: #333;
  }
  
  .loader-overlay.dark .loader-message,
  .loader-inline.dark .loader-message {
    color: #eee;
  }
  
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  </style>
  